/* eslint-disable react/require-default-props */
import React, { useState } from 'react';
import CommentInput from 'components/molecules/comment_input';
import { Container } from './styles';

export interface ChecklistItemView {
  key: string;
  content: string;
  done: boolean;
}

interface AiManagementChecklistProps {
  items: ChecklistItemView[];
  total?: number;
  done?: number;
  onAdd?: (content: string) => void;
  onRemove?: (key: string) => void;
  onToggle?: (key: string) => void;
}

const AiManagementChecklist: React.FC<AiManagementChecklistProps> = ({
  items,
  total,
  done,
  onAdd,
  onRemove,
  onToggle,
}) => {
  const [adding, setAdding] = useState(false);

  const itemsTotal = total ?? items.length;
  const itemsDone = done ?? items.filter((item) => item.done).length;
  const progress = itemsTotal ? Math.round((itemsDone / itemsTotal) * 100) : 0;

  const handleAdd = (content: string) => {
    if (!onAdd) return;
    onAdd(content);
    setAdding(false);
  };

  return (
    <Container>
      <div className="d-flex align-items-center mb-2">
        <span className="checklist-percent text-muted mr-2">{progress}%</span>
        <div className="progress checklist-progress flex-grow-1">
          <div
            className={`progress-bar ${progress === 100 ? 'bg-success' : ''}`}
            role="progressbar"
            aria-label="Progresso do checklist"
            style={{ width: `${progress}%` }}
            aria-valuenow={progress}
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>
      </div>

      {itemsTotal === 0 && !adding && (
        <div className="text-muted mb-2">Nenhum item no checklist ainda.</div>
      )}

      {items.map((item) => (
        <div key={item.key} className="checklist-item d-flex align-items-start">
          <div className="custom-control custom-checkbox flex-grow-1">
            <input
              type="checkbox"
              className="custom-control-input"
              id={`checklist-${item.key}`}
              checked={item.done}
              onChange={() => onToggle?.(item.key)}
              readOnly={!onToggle}
            />
            <label
              className={`custom-control-label ${item.done ? 'checklist-item-done' : ''}`}
              htmlFor={`checklist-${item.key}`}
            >
              {item.content}
            </label>
          </div>
          {onRemove && (
            <button
              type="button"
              className="checklist-remove btn btn-link p-0 text-muted d-flex align-items-center ml-2"
              aria-label={`Remover ${item.content}`}
              onClick={() => onRemove(item.key)}
            >
              <i className="material-icons">close</i>
            </button>
          )}
        </div>
      ))}

      {onAdd && !adding && (
        <button
          type="button"
          className="btn btn-link text-primary p-0 d-flex align-items-center mt-2"
          onClick={() => setAdding(true)}
        >
          <i className="material-icons mr-1">add</i>
          Adicionar um item
        </button>
      )}

      {onAdd && adding && (
        <div className="mt-2">
          <CommentInput isLoading={false} createComment={handleAdd} commentSource="ai_management" />
          <button
            type="button"
            className="btn btn-link text-muted p-0 mt-1"
            onClick={() => setAdding(false)}
          >
            Cancelar
          </button>
        </div>
      )}
    </Container>
  );
};

export default AiManagementChecklist;
